import { translations, languages, normalizeLanguageCode } from './translations';

export const t = (key, language = 'el') => {
  const normalizedLang = normalizeLanguageCode(language);
  const keys = key.split('.');
  
  let value = translations[normalizedLang];
  
  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      console.warn(`Translation missing for ${key} in ${normalizedLang}`);
      return key;
    }
  }
  
  return value;
};

export const getCultureInfo = (language) => {
  const normalizedLang = normalizeLanguageCode(language);
  return languages[normalizedLang]?.culture || 'el-GR';
};

export const getAvailableLanguages = () => {
  return Object.entries(languages).map(([code, config]) => ({
    code,
    name: config.name,
    flag: config.flag,
    culture: config.culture
  }));
};